module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAb1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABt6r1GAAAAJXRSTlMAvCQdCi7cyqgZBsK2gWxb2dCVVhDSnZiLdDQpFKCIY1BLRToO4rhonQAAAJpJREFUGNOVkNsOgyAMhqscBQEVPEzdee//jBuELGXLLvZd9E+/pG1S+J+G1Z+Kzpx3rimcquQWmNYUSy9iS4cJy6NJsYoHku0hRT0235K0BEkzp7iLHUnWxTlanQFjWlDghCok42SwZijUqV9A+tBJ/z7vxukCSjogVvf5A6Rf4xVhY2O1yvs28mK5xnrjIcm9wkjI8zWCwg+eTR4F+JN05EYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/account.png
// module id = oFXm
// module chunks = 1